export default __webpack_public_path__ + "static/media/background-landing-3.872b93a1.jpg";